"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var allowed_1 = __importDefault(require("../utils/allowed"));
function TdInner(props) {
    var headers = props.headers, children = props.children, columnKey = props.columnKey, className = props.className, colSpan = props.colSpan;
    var classes = "".concat(className || '', " pivoted");
    if (colSpan) {
        return react_1.default.createElement("td", __assign({ "data-testid": "td" }, (0, allowed_1.default)(props)));
    }
    return (react_1.default.createElement("td", __assign({ "data-testid": "td" }, (0, allowed_1.default)(props), { className: classes }),
        react_1.default.createElement("div", { "data-testid": "td-before", className: "tdBefore" }, headers[columnKey]), children !== null && children !== void 0 ? children : react_1.default.createElement("div", null, "\u00A0")));
}
exports.default = TdInner;
